
import objectHash from 'object-hash';

interface MemoizationObject {
  body: any;

  last: Date;
}

class AsyncMemoization {
  private static asyncMemoizator: AsyncMemoization | null = null;

  private timeout = 1000 * 60 * 5; // 5 min

  private memoizationMap: Record<string, MemoizationObject> = {};

  constructor() {
    if (AsyncMemoization.asyncMemoizator) {
      return AsyncMemoization.asyncMemoizator;
    }
    this.init();
    AsyncMemoization.asyncMemoizator = this;
  }

  init() {
    console.log('AsyncMemoization init');
  }

  memoize(request: any, response: any) {
    const hash = objectHash.sha1(request);
    this.memoizationMap[hash] = {
      last: new Date(),
      body: response,
    };
  }

  extract(request: any): any {
    const hash = objectHash.sha1(request);
    const memoized = this.memoizationMap[hash];
    if (!memoized || ((new Date()).getTime() - memoized.last.getTime()) > this.timeout) {
      return null;
    }
    return memoized.body;
  }
}


export default AsyncMemoization;
